const templateUrl = require('./cancel-subscription-button.html');

module.exports = {
  bindings: {
    subscription: '<ogFor'
  },
  templateUrl: templateUrl
};
